<template>
	<div class="dot-menu" ref="dot-menu">
		<span class="dot-menu-overlay" @pointerdown="clickOverlay()" v-show="opened"></span>
		<span class="dot-menu-handler" tabindex="0" @focus="open" @focusout="focusout">
			<svg class="dot-menu-handler-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/></svg>
		</span>
		<transition name="fade" mode="out-in" appear>
			<ul :class="[alignment ? alignment : '', 'dot-menu-list']" v-show="opened">
				<slot/>
			</ul>
		</transition>
	</div>
</template>

<script>
export default {
	name: 'DotMenu',
	props: ['alignment'],
	data() {
		return {
			opened: false,
		}
	},
	methods: {
		open() {
			this.opened = true;
		},
		close() {
			this.opened = false;
		},
		focusout(e) {
			if (getClosest(e.relatedTarget, this.$refs['dot-menu']) != this.$refs['dot-menu']) {
				this.close();
			}
		},
		clickOverlay() {
			document.activeElement.blur();
			/*this.close();*/
		}
	},
}
</script>

<style scoped>
.dot-menu {
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}

.dot-menu .dot-menu-overlay {
	position: fixed;
	display: block;
	top: 0;
	right: 0;
	width: 100%;
	height: 100%;
	margin: 0;
	background-color: transparent;
	z-index: 200;
}

.dot-menu .dot-menu-handler {
	cursor: pointer;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 50%;
	font-size: 2.4rem;
	width: 3.2rem;
	height: 3.2rem;
	margin: 0;
	cursor: pointer;
	outline: none;
}

.dot-menu .dot-menu-handler:hover {
	background-color: rgba(158, 158, 158, 0.2);
}

.dot-menu .dot-menu-handler:focus:not(:active) {
	background-color: rgba(0, 0, 0, 0.12);
}

.dot-menu .dot-menu-handler:active {
	background-color: rgba(158, 158, 158, 0.4);
}

.dot-menu .dot-menu-handler-icon {
	display: block;
	width: 100%;
	height: 100%;
}

.dot-menu-list.right {
	left: inherit;
	right: 50%;
}

.dot-menu-list.bottom {
	top: inherit;
	bottom: 50%;
}

.dot-menu-list {
	list-style: none;
	position: absolute;
	top: 50%;
	left: 50%;
	background: #fff;
	box-shadow: 0 .2rem .2rem 0 rgba(0, 0, 0, 0.14), 0 .3rem .1rem -.2rem rgba(0, 0, 0, 0.2),
		0 .1rem .5rem 0 rgba(0, 0, 0, 0.12);
	padding: 0;
	margin: 0;
	/*padding: .8rem 0;*/
	z-index: 300;
}
</style>